import mixin from '@/store/mixins/data-grid'

const { stateMixin, gettersMixin, mutationsMixin, actionsMixin } = mixin

const state = {
  ...stateMixin('auth:user', 'created_at')
}

const getters = {
  ...gettersMixin()
}

const mutations = {
  ...mutationsMixin()
}

const actions = {
  ...actionsMixin({
    http: {
      headers: {
        'x-user-type': 'admin'
      }
    }
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
